import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { ListagemGestantePuerperaVisitasDomiciliaresModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSectionProps {
  visitasDomiciliares: ListagemGestantePuerperaVisitasDomiciliaresModel
  iconColor?: Color
}

const VACINACAO_TOOLTIP_TEXT = 'Apenas visitas de acompanhamento com o motivo preenchido como '

export function AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection({
  visitasDomiciliares,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='houseFilled' color={iconColor} />
          <Text fontWeight='bold'>Visitas domiciliares</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25} alignItems='center'>
            <Text fontWeight='bold'>Pré-natal</Text>
            <InfoIcon icon='infoCircleFilled' text={VACINACAO_TOOLTIP_TEXT + 'Gestante'} />
          </HFlow>
          <Text>{visitasDomiciliares?.visitasDomiciliaresPreNatal ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25} alignItems='center'>
            <Text fontWeight='bold'>Puerpério</Text>
            <InfoIcon icon='infoCircleFilled' text={VACINACAO_TOOLTIP_TEXT + 'Puérpera'} />
          </HFlow>
          <Text>{visitasDomiciliares?.visitasDomiciliaresPuerperio ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
